package com.appsyde.shared.presentation.style

import com.appsyde.shared.presentation.style.token.AppStylesTokens
import org.jetbrains.compose.web.css.*

object AppStylesTicketHeader : StyleSheet() {

    /* ==============================
       LEFT HEADER (BACK + TITLE)
       ============================== */

    val ticketHeaderLeft by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(14.px)
        minWidth(0.px)
    }

    val ticketBackButton by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)

        width(34.px)
        height(34.px)
        borderRadius(999.px)
        padding(0.px)
        property("border", "none")
        property("appearance", "none")

        backgroundColor(Color("rgba(15,16,35,0.00)"))
        color(Color("rgba(60, 66, 110, 0.62)"))

        cursor("pointer")
        property("flex", "0 0 auto")
        property("user-select", "none")
        property("-webkit-tap-highlight-color", "transparent")

        property(
            "transition",
            "background-color 160ms ease, color 160ms ease, transform 160ms ease"
        )

        self + hover style {
            backgroundColor(Color("rgba(15,16,35,0.045)"))
            color(Color("rgba(70, 78, 220, 0.90)"))
        }

        self + active style {
            property("transform", "translateY(0.5px)")
        }

        self + focus style {
            property("outline", "none")
            property("box-shadow", AppStylesTokens.FOCUS_RING)
        }
    }

    val ticketHeaderTitleWrap by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(0.px)
        minWidth(0.px)
    }

    /* ==============================
       TITLE
       ============================== */
    val ticketHeaderTitleRow by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Baseline)
        justifyContent(JustifyContent.SpaceBetween)

        gap(16.px)

        property("min-width", "0")
    }
    val ticketHeaderTitle by style {
        fontSize(18.px)
        fontWeight(600)
        fontStyle("normal")              // pas d’italique
        color(Color("rgba(15,23,42,0.88)"))

        letterSpacing((-0.15).px)
        lineHeight("1.25")

        property("white-space", "nowrap")
        property("overflow", "hidden")
        property("text-overflow", "ellipsis")
        property("min-width", "0")
        property("flex", "1 1 auto")

        property("transition", "color 160ms ease")
    }

    /* ==============================
       RIGHT HEADER (ACTIONS)
       ============================== */

    val ticketHeaderRight by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(10.px)
    }

    val ticketHeaderActionsRow by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(10.px)
    }

    /* ==============================
       HISTORIQUE PILL
       ============================== */
    /* ==============================
       HISTORIQUE (INLINE LINK)
       ============================== */

    val historyInline by style {
        display(DisplayStyle.LegacyInlineFlex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        padding(8.px, 12.px)
        borderRadius(999.px)
        border(1.px, LineStyle.Solid, Color("rgba(70, 78, 220, 0.20)"))
        backgroundColor(Color("rgba(70, 78, 220, 0.00)"))
        color(Color("rgba(70, 78, 220, 0.70)"))

        fontSize(12.px)
        fontWeight(600)
        letterSpacing(0.2.px)
        cursor("pointer")

        property("user-select", "none")
        property("-webkit-tap-highlight-color", "transparent")
        property("transition", "background-color 150ms ease, border-color 150ms ease, color 150ms ease, box-shadow 150ms ease")

        self + hover style {
            backgroundColor(Color("rgba(70, 78, 220, 0.06)"))
            color(Color("rgba(70, 78, 220, 0.80)"))
            property("border-color", "rgba(70, 78, 220, 0.24)")
        }

        self + focus style {
            property("outline", "none")
            property("box-shadow", AppStylesTokens.FOCUS_RING)
        }

    }

    val historyInlineDisabled by style {
        opacity(0.7)
        cursor("default")
        property("pointer-events", "none")
    }

    val historyInlineText by style {
        whiteSpace("nowrap")
        lineHeight("1")
    }




    /* ==============================
       STATUS BADGE
       ============================== */

    val headerBadge by style {
        display(DisplayStyle.LegacyInlineFlex)
        alignItems(AlignItems.Center)

        padding(8.px, 12.px)
        borderRadius(999.px)

        fontSize(12.px)
        fontWeight(700)
        letterSpacing(0.5.px)

        cursor("pointer")
        property("appearance", "none")
        property("touch-action", "manipulation")
        property("-webkit-tap-highlight-color", "transparent")
        property("transition", "background-color 160ms ease, border-color 160ms ease, color 160ms ease, box-shadow 160ms ease")


    }

    val headerBadgeOpen by style {
        backgroundColor(Color("rgba(34,197,94,0.08)"))
        border {
            style(LineStyle.Solid)
            width(1.px)
            color(Color("rgba(22,163,74,0.18)"))
        }
        color(Color("rgba(22,163,74,0.92)"))
    }

    val headerBadgeWaiting by style {
        backgroundColor(Color(AppStylesTokens.STATUS_WAITING_SOFT))
        border {
            style(LineStyle.Solid)
            width(1.px)
            color(Color("rgba(180,83,9,0.28)"))
        }
        color(Color(AppStylesTokens.STATUS_WAITING))
    }

    val headerBadgeClosed by style {
        backgroundColor(Color("rgba(100, 116, 139, 0.10)"))
        border {
            style(LineStyle.Solid)
            width(1.px)
            color(Color("rgba(100, 116, 139, 0.22)"))
        }
        color(Color("rgba(51, 65, 85, 0.90)"))
    }

    /** Bouton navigation ticket suivant (>) à droite du statut */
    val headerSkipButton by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        width(36.px)
        height(36.px)
        padding(0.px)
        borderRadius(10.px)
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.08)"))
        backgroundColor(Color("rgba(255,255,255,0.9)"))
        color(Color("rgba(15,23,42,0.65)"))
        fontSize(16.px)
        fontWeight(600)
        property("cursor", "pointer")
        property("transition", "background-color 140ms ease, color 140ms ease, border-color 140ms ease")
        self + hover style {
            backgroundColor(Color("rgba(102,96,230,0.08)"))
            color(Color("rgba(59,70,212,0.88)"))
            border(1.px, LineStyle.Solid, Color("rgba(102,96,230,0.18)"))
        }
    }
}
